import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import queryString from 'query-string';
import useObjectKeysMemoize from './useObjectKeysMemoize.js';
import { EMPTY_OBJ, LoginByCodeDefaultProps } from '../Constants.js';
export default function useLoginByCode(opts) {
  const {
    classNames = EMPTY_OBJ,
    variants: pVariants,
    options: pOptions,
    components: pComponents,
    onBackToLogin,
    onLogin,
    onAfterLogin,
    onLoginError,
    ...restProps
  } = opts;
  const username = useRef();
  useEffect(() => {
    const q = queryString.parse(window.location.search);
    if (!q.u || q.u.trim().length === 0) {
      onBackToLogin();
    } else {
      username.current = q.u;
    }
  }, []);
  const v = useObjectKeysMemoize(pVariants);
  const variants = useMemo(() => {
    return {
      ...LoginByCodeDefaultProps.variants,
      ...v
    };
  }, [v]);
  const o = useObjectKeysMemoize(pOptions);
  const options = useMemo(() => {
    return {
      ...LoginByCodeDefaultProps.options,
      ...o
    };
  }, [o]);
  const c = useObjectKeysMemoize(pComponents);
  const components = useMemo(() => {
    return {
      ...LoginByCodeDefaultProps.components,
      ...c
    };
  }, [c]);
  const rest = useObjectKeysMemoize(restProps);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [submitted, setSubmitted] = useState();
  const onSubmit = useCallback(({
    code
  }) => {
    setLoading(true);
    setError(null);
    const prom = onLogin?.(username.current, code.trim());
    if (prom?.then) {
      prom.then((...args) => {
        setSubmitted(true);
        return onAfterLogin?.(...args);
      }).catch(err => {
        setError(err);
        onLoginError?.(err);
        setLoading(false);
      });
    } else {
      setSubmitted(true);
      setLoading(false);
    }
  }, [onLogin, onAfterLogin, onLoginError]);
  return useMemo(() => {
    return {
      classNames,
      variants,
      options,
      components,
      state: {
        error,
        loading,
        onSubmit,
        submitted
      },
      ...rest,
      onBackToLogin
    };
  }, [classNames, components, error, loading, onBackToLogin, onSubmit, options, rest, submitted, variants]);
}